<template>
  <wc-data-box
    title='Contacts'
    :titleIcon='$store.state.icons.modules.clients.icon'
    :titleIconColor='$store.state.icons.modules.clients.color'
  >
    <template v-slot:toolbarButtons>
      <v-btn small depressed color='primary' width='76px' @click='showContacts=!showContacts'>
        <v-icon x-small class='mr-1'>{{ showContacts ? 'mdi-arrow-expand-up' : 'mdi-arrow-expand-down' }}</v-icon>
        {{  showContacts ? 'Hide' : 'Show' }}
      </v-btn>
    </template>
    <div v-if='showContacts'>
      <v-simple-table outlined dense>
        <tbody>
          <tr v-for='(contact, index) in contacts' :key='index'>
            <td>
              <div class='font-weight-bold'>{{ contact.role }}</div>
              <div>{{ contact.name_display }}</div>
              <div v-if='contact.main_phone'>
                <span class='mr-2 mb-2' :class='label'>Home:</span>
                <a :href='"tel:" + contact.main_phone' style='text-decoration: none;'>{{ contact.main_phone }}</a>
              </div>
              <div v-if='contact.home_phone'>
                <span class='mr-2 mb-2' :class='label'>Home:</span>
                <a :href='"tel:" + contact.home_phone' style='text-decoration: none;'>{{ contact.home_phone }}</a>
              </div>
              <div v-if='contact.cell_phone'>
                <span class='mr-2 mb-2' :class='label'>Cell:</span>
                <a :href='"tel:" + contact.cell_phone' style='text-decoration: none;'>{{ contact.cell_phone }}</a>
              </div>
              <div v-if='contact.work_phone'>
                <span class='mr-2 mb-2' :class='label'>Work:</span>
                <a :href='"tel:" + contact.work_phone' style='text-decoration: none;'>{{ contact.work_phone }}</a>
                <span v-if='contact.work_phone_ext' class='ml-4 mr-2 mb-2' :class='label'>{{ "Ext: " + contact.work_phone_ext }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </wc-data-box>
</template>

<script>


export default {
  name: 'fc-contacts',
  props: {
    wo: {
      required: true
    },
  },
  data: () => ({
    showContacts: false,
    label: 'grey--text text--darken-2 text-left text-no-wrap',
    dataValue: 'text-right pt-2 px-2'
  }),
  computed: {
    obj () {
      if (this.wo.estimate) {
        return this.wo.estimate_obj
      } else {
        return this.wo.project_obj
      }
    },
    contacts () {
      let array = [{role: "Owner", name_display: "None...", home_phone: "", cell_phone: "", work_phone: "" }]
      if (this.obj.owner) {
        array.splice(0, 1, {
          role: "Owner",
          name_display: this.obj.owner_obj.name_display,
          home_phone: this.obj.owner_obj.home_phone,
          cell_phone: this.obj.owner_obj.cell_phone,
          work_phone: this.obj.owner_obj.work_phone,
          work_phone_ext: this.obj.owner_obj.work_phone_extension
        })
      }
      if (this.obj.site_contact && this.obj.site_contact !== this.obj.owner) {
        array.push({
          role: "Site Contact",
          name_display: this.obj.site_contact_obj.name_display,
          home_phone: this.obj.site_contact_obj.home_phone,
          cell_phone: this.obj.site_contact_obj.cell_phone,
          work_phone: this.obj.site_contact_obj.work_phone,
          work_phone_ext: this.obj.site_contact_obj.work_phone_extension
        })
      }
      if (this.obj.secondary_site_contact && this.obj.secondary_site_contact !== this.obj.site_contact && this.obj.secondary_site_contact !== this.obj.owner) {
        array.push({
          role: "Secondary Site Contact",
          name_display: this.obj.secondary_site_contact_obj.name_display,
          home_phone: this.obj.secondary_site_contact_obj.home_phone,
          cell_phone: this.obj.secondary_site_contact_obj.cell_phone,
          work_phone: this.obj.secondary_site_contact_obj.work_phone,
          work_phone_ext: this.obj.secondary_site_contact_obj.work_phone_extension
        })
      }
      if (this.obj.service_contact && this.obj.service_contact !== this.obj.owner) {
        array.push({
          role: "Service Contact",
          name_display: this.obj.service_contact_obj.name_display,
          home_phone: this.obj.service_contact_obj.home_phone,
          cell_phone: this.obj.service_contact_obj.cell_phone,
          work_phone: this.obj.service_contact_obj.work_phone,
          work_phone_ext: this.obj.service_contact_obj_obj.work_phone_extension
        })
      }
      if (this.obj.secondary_service_contact && this.obj.secondary_service_contact !== this.obj.service_contact  && this.obj.secondary_service_contact !== this.obj.owner) {
        array.push({
          role: "Secondary Service Contact",
          name_display: this.obj.secondary_service_contact_obj.name_display,
          home_phone: this.obj.secondary_service_contact_obj.home_phone,
          cell_phone: this.obj.secondary_service_contact_obj.cell_phone,
          work_phone: this.obj.secondary_service_contact_obj.work_phone,
          work_phone_ext: this.obj.secondary_service_contact_obj.work_phone_extension
        })
      }
      return array
    },
  },
  methods: {

  }
}
</script>